import Vue from 'vue';

const DEBUG_ENABLED = process.env.VUE_APP_DEBUG === 'true';
const DISABLED_METHODS = ['log', 'info', 'debug', 'trace'];
const originalConsole = {};

if (typeof console !== 'undefined') {
  DISABLED_METHODS.forEach((method) => {
    originalConsole[method] = console[method] ? console[method].bind(console) : () => {};
  });
  originalConsole.warn = console.warn ? console.warn.bind(console) : () => {};
  originalConsole.error = console.error ? console.error.bind(console) : () => {};
}

const logger = {
  enabled: DEBUG_ENABLED,

  init() {
    if (typeof console === 'undefined' || this.enabled) {
      return;
    }

    DISABLED_METHODS.forEach((method) => {
      console[method] = () => {};
    });
  },

  install() {
    Vue.prototype.$log = this;
  },

  log(...args) {
    if (this.enabled) {
      originalConsole.log(...args);
    }
  },

  info(...args) {
    if (this.enabled) {
      originalConsole.info(...args);
    }
  },

  debug(...args) {
    if (this.enabled) {
      originalConsole.debug(...args);
    }
  },

  trace(...args) {
    if (this.enabled) {
      originalConsole.trace(...args);
    }
  },

  warn(...args) {
    originalConsole.warn(...args);
  },

  error(...args) {
    originalConsole.error(...args);
  },
};

logger.init();

export default logger;
